import { SpecificPriceRuleModelType } from '@teinor/erp/types/company/product/specificPriceRule/'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'

interface SpecificPriceRuleModelTypeExt extends SpecificPriceRuleModelType {
    fullname: string
}
export type SpecificPriceRulesDict = { [SpecificPriceRuleId: string]: SpecificPriceRuleModelTypeExt }

export type SpecificPriceRules = {
    dictionary: SpecificPriceRulesDict
    arrSorted: SpecificPriceRuleModelType[]
    defaultSpecificPriceRuleId: number
}

export interface SpecificPriceRulesAction {
    type: 'CHANGE_SPECIFICPRICERULES'
    payload: SpecificPriceRuleModelType[]
}

export type SpecificPriceRulesPayload = SpecificPriceRules | null

export default function specificPriceRules(state: SpecificPriceRulesPayload = null, action: SpecificPriceRulesAction): SpecificPriceRules | null {
    switch (action.type) {
        case 'CHANGE_SPECIFICPRICERULES':
            return state = { dictionary: dictionaryComplexFromJsonArr(action.payload, undefined, undefined, undefined, (item: any) => { return { ...item, fullname: 'T' + item.id + ' - ' + item.name } }), arrSorted: action.payload, defaultSpecificPriceRuleId: action.payload[0].id }
        default:
            return state
    }
}